import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { antiFraudActions } from '../../actions'
import * as config from 'config'

const second = 1000
const minute = 60 * second
const hour = 60 * minute

/**
 * This component is needed for Anti-Fraud in payment pages.
 *
 * It generates a session_id and provides it in the store using redux
 * It injects a needed script at the head section
 */
class AntiFraud extends Component {
	constructor(props) {
		super(props)
		this.id = 'antiFraud'
	}

	componentWillMount() {
		// this.props.generateSessionID()

		// setTimeout(() => {
		// 	this.injectScript()
		// }, 100)
	}

	getScriptSrc = () => {
		const { sessionID, isPoints } = this.props

		const baseURL = 'h.online-metrix.net/fp/tags.js'
		return `https://${baseURL}?org_id=${config.antiFraudOrgID}&session_id=${sessionID}`
	}

	getScript = () => {
		const script = document.createElement('script')
		script.setAttribute('id', this.id)
		script.setAttribute('type', 'text/javascript')
		script.setAttribute('src', this.getScriptSrc())

		return script
	}

	injectScript = () => {
		const script = this.getScript()
		let head = document.querySelector('head')
		head.appendChild(script)
	}

	renewScriptSessionId = () => {
		const { generateSessionID } = this.props

		generateSessionID()
		document.querySelector(`script#${this.id}`).remove()
		this.injectScript()
	}

	render() {
		return null
	}
}

const mapStateToProps = ({ antiFraud }) => {
	return { sessionID: antiFraud.sessionID }
}

const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...antiFraudActions }, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AntiFraud)
